import { ck, interact, $subscriber } from "fire-wind-water";
import { sxhr } from "fire-wind-water/sxhr";
import api from "./services/api";
class Slient {
  constructor() {
    this.ip = "";
    this.init();
  }

  init() {
    sxhr.getScript("//api.smarket.net.cn/cityjson?ie=utf-8").then(() => {
      this.ip = window.returnCitySN.cip;
      // if (!ck.cookie(`globalUserId`)) {
      //   this.getAnonymousId();
      // }
    });
  }

  getAnonymousId() {
    if (this.ip) {
      api
        .getAnonymousId({
          clientVersion: interact.browseInfo.version,
          clientBrand: interact.browseInfo.browser,
          clientType: interact.browseInfo.os,
          clientIP: this.ip
        })
        .subscribe(data => {
          ck.cookie("globalUserId", data.content, {
            expires: 365,
            domain: window.$sk.config.domain,
            path: "/"
          });
          $subscriber.emit("globalUserId-loaded", data.content);
        });
    } else {
      sxhr.getScript("//api.smarket.net.cn/cityjson?ie=utf-8").then(() => {
        this.ip = window.returnCitySN.cip;
        api
          .getAnonymousId({
            clientVersion: interact.browseInfo.version,
            clientBrand: interact.browseInfo.browser,
            clientType: interact.browseInfo.os,
            clientIP: this.ip
          })
          .subscribe(data => {
            ck.cookie("globalUserId", data.content, {
              expires: 365,
              domain: window.$sk.config.domain,
              path: "/"
            });
            $subscriber.emit("globalUserId-loaded", data.content);
          });
      });
    }
  }
}

export function getGlobalUserId() {
  const scr = new Slient();
  scr.getAnonymousId();
}

export { Slient };
